import { callCancelHotelVouchers } from '@/api/passenger'

const cancelHotelVouchers = (context, payload) => {
  return callCancelHotelVouchers(payload).then((response) => {
    return response
  })
}

export default {
  cancelHotelVouchers
}
